/**
 * @file Homepage Testimonials.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Testimonials component.
 */
const vTestimonials = () => {
	const testimonials = document.querySelector('.v-testimonials');

	if (!testimonials) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const quoteMarks = testimonials.querySelectorAll('.v-testimonials__marks');
	[...quoteMarks].forEach((quoteMark) => gsap.from(quoteMark, {
		rotate:        -160,
		ease:          'sine.out',
		duration:      0.5,
		scrollTrigger: {
			trigger:       quoteMark,
			start:         'center bottom',
			end:           '+=1',
			toggleActions: 'play none none reverse',
		},
	}));
};

export default vTestimonials;
